module.exports = __webpack_public_path__ + "img/dislike.079e8801.svg";